import { api } from "@/lib/axios";

const setTokenToUser = (userId: string, token: string): Promise<void> =>
    api.put("/users/push/token", {
        token,
        userId,
    }).catch(() => null) as unknown as Promise<void>;

export default setTokenToUser;
